(() => {
  const landing = document.querySelector('[data-rly-combustion]');
  const variantId = Number(landing?.dataset.variantId);
  const hero = document.querySelector('[data-hero]');
  const sticky = document.querySelector('[data-sticky]');
  if (hero && sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0.08 }).observe(hero);
  }

  const cooks = {
    roast: { name: 'ROAST', target: '130°F', time: '05:34', core: '114°', surface: '168°', ambient: '275°' },
    chicken: { name: 'CHICKEN', target: '165°F', time: '00:42', core: '148°', surface: '176°', ambient: '350°' },
    brisket: { name: 'BRISKET', target: '203°F', time: '02:18', core: '187°', surface: '193°', ambient: '250°' },
    salmon: { name: 'SALMON', target: '130°F', time: '00:11', core: '118°', surface: '136°', ambient: '400°' }
  };
  let selectedCook = 'roast';
  let selectedMetric = 'core';
  const updateScreen = () => {
    const cook = cooks[selectedCook];
    document.querySelector('[data-screen-name]').textContent = cook.name;
    document.querySelector('[data-screen-temp]').textContent = cook[selectedMetric];
    document.querySelector('[data-screen-target]').textContent = cook.target;
    document.querySelector('[data-screen-time]').textContent = cook.time;
  };
  document.querySelectorAll('[data-cook]').forEach(button => button.addEventListener('click', () => {
    selectedCook = button.dataset.cook;
    document.querySelectorAll('[data-cook]').forEach(item => { item.classList.toggle('is-active', item === button); item.setAttribute('aria-selected', item === button); });
    updateScreen();
  }));
  document.querySelectorAll('[data-metric]').forEach(button => button.addEventListener('click', () => {
    selectedMetric = button.dataset.metric;
    document.querySelectorAll('[data-metric]').forEach(item => item.classList.toggle('is-active', item === button));
    updateScreen();
  }));

  document.querySelectorAll('[data-add]').forEach(button => {
    button.addEventListener('click', async () => {
      button.disabled = true;
      const original = button.innerHTML;
      try {
        if (location.hostname === 'rarely.co' && variantId) {
          const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }) });
          if (!response.ok) throw new Error('Cart unavailable');
          button.textContent = 'Added to cart';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } else button.textContent = 'Ready for Shopify';
      } catch (_) { button.textContent = 'Try again'; }
      finally { setTimeout(() => { button.disabled = false; button.innerHTML = original; }, 1800); }
    });
  });
})();
